import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { typeSelected } from "../features/filter/filterSlice";

export default function Sidebar() {
  const { type } = useSelector(state => state.filter)
  const dispatch = useDispatch();

  const navigate = useNavigate()

  const handleTypeChange = (type) => {
    if (type == '') {
      navigate('/');
      dispatch(typeSelected(''))
      return;
    }
    dispatch(typeSelected(type))
  }

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <button onClick={() => handleTypeChange('')} className="main-menu menu-active" id="lws-alljobs-menu">
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </button>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <button onClick={() => handleTypeChange('Internship')} className="sub-menu" id="lws-internship-menu">
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                  Internship
                </button>
              </li>
              <li>
                <button onClick={() => handleTypeChange('Full Time')} className="sub-menu" id="lws-fulltime-menu">
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                  Full Time
                </button>
              </li>
              <li>
                <button onClick={() => handleTypeChange('Remote')} className="sub-menu" id="lws-remote-menu">
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                  Remote
                </button>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/addedit" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus"></i>
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  )
}